module.exports = __webpack_public_path__ + "img/pawprint.8da9acfb.svg";